import axios from 'axios';
import { BASEURL } from '../config';

const authService = {
  // Verify 2FA code
  verify2FA: async (email: string, code: string) => {
    try {
      const response = await axios.post(`${BASEURL}auth/verify-2fa`, {
        email,
        otp:code,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Request new 2FA code
  request2FACode: async (email: string) => {
    try {
      const response = await axios.post(`${BASEURL}auth/request-2fa`, {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Enable 2FA for a user
  enable2FA: async (email: string) => {
    try {
      const response = await axios.post(`${BASEURL}/auth/enable-2fa`, {
        email,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default authService; 